import { StyleSheet } from 'aphrodite'

import user from './user'
import list from './list'

import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  user: StyleSheet.create(user),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/User/partials/UserTable/style/index.js